import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <h1>Mumbai Pav Recipe Helper</h1>
      <p>Accurate ingredients, proper timing, and the right environment for dough rising are all critical for successful pav. This interactive guide provides tips at the right moments throughout the baking process. Use this site while you bake to easily track your progress and know what comes next.</p>
    </header>
  );
}

export default Header;